<template>
  <div class="h100">
    <div
      class="leftMenu"
      v-loading="loading"
      :style="isBotBut ? 'height: calc(100% - 40px);' : ''"
    >
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        :key="activeIndex"
        ref="menuTree"
        @select="MenuSelect"
        style="height: 100%"
      >
        <component
          v-for="item in MenuList"
          :key="item.Id"
          :index="
            JSON.stringify({
              BuildingId: item.BuildingId || '',
              DeviceType: item.Id || '',
              InstallationArea: item.InstallationArea || '',
              TreeType: item.TreeType || 0,
            })
          "
          :is="item.Type == 3 ? 'el-menu-item' : 'el-submenu'"
        >
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>{{ item.title }}</span>
          </template>
          <component
            v-for="ele in item.Children"
            :key="ele.title"
            :index="
              JSON.stringify({
                BuildingId: ele.BuildingId || '',
                DeviceType: ele.Id || '',
                InstallationArea: ele.InstallationArea || '',
                TreeType: ele.TreeType || 0,
              })
            "
            :is="ele.Type == 4 ? 'el-submenu' : 'el-menu-item'"
            popper-class="popper-menu"
          >
            <template slot="title">
              <i
                :class="
                  ele.Type == 4 ? 'el-icon-school' : 'el-icon-edit-outline'
                "
              ></i>
              <span>{{ ele.title }}</span>
            </template>
            <template v-if="ele.Children && ele.Children.length > 0">
              <el-menu-item
                class="menu-item"
                v-for="v in ele.Children"
                :key="v.Id"
                :index="
                  JSON.stringify({
                    BuildingId: v.BuildingId || '',
                    DeviceType: v.Id || '',
                    InstallationArea: v.InstallationArea || '',
                    TreeType: v.TreeType || 0,
                  })
                "
              >
                <i class="el-icon-edit-outline"></i>
                <span slot="title">{{ v.title }}</span>
              </el-menu-item>
            </template>
          </component>
          <!-- <el-menu-item v-for="ele in item.Children" :key="ele.Id" :index="ele.path">
            <i
              :class="
                ele.Type == 4 || ele.Type == 5
                  ? 'el-icon-edit-outline'
                  : 'el-icon-document'
              "
            ></i>
            {{ ele.title }}
          </el-menu-item> -->
        </component>
      </el-menu>
    </div>
    <div class="tabsBut" v-if="isBotBut">
      <el-tabs type="border-card" v-model="TreeType" @tab-click="menuChange">
        <el-tab-pane label="楼栋" name="0"></el-tab-pane>
        <el-tab-pane label="机房" name="1"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      activeIndex: '',
      MenuList: [],
      loading: false,
      isBotBut: false,
      TreeType: '0',
    }
  },
  props: {},
  components: {},
  methods: {
    ...mapMutations([
      'setdevTreeSearch', // 将 `this.setdevTreeSearch()` 映射为 `this.$store.commit('increment')`
    ]),
    menuChange(tab) {
      this.TreeType = tab.name
      window.sessionStorage.setItem('TreeType', this.TreeType)
      this.getMenuList(true)
    },
    getMenuList(isChange) {
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetProjectTreeData?TreeType=' + this.TreeType)
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.MenuList = resJson.Data

            if (isChange) {
              let item = this.MenuList[0] || {}
              window.sessionStorage.setItem(
                'devTreeSearch',
                JSON.stringify({
                  BuildingId: item.BuildingId || '',
                  DeviceType: item.Id || '',
                  InstallationArea: item.InstallationArea || '',
                  TreeType: item.TreeType || 0,
                })
              )
              this.setdevTreeSearch(
                JSON.parse(
                  window.sessionStorage.getItem('devTreeSearch') || '{}'
                )
              )
            }

            if (window.sessionStorage.getItem('devTreeSearch')) {
              let obj = JSON.parse(
                window.sessionStorage.getItem('devTreeSearch')
              )
              if (obj.TreeType != this.TreeType) {
                let item = this.MenuList[0] || {}
                window.sessionStorage.setItem(
                  'devTreeSearch',
                  JSON.stringify({
                    BuildingId: item.BuildingId || '',
                    DeviceType: item.Id || '',
                    InstallationArea: item.InstallationArea || '',
                    TreeType: item.TreeType || 0,
                  })
                )
                this.setdevTreeSearch(
                  JSON.parse(
                    window.sessionStorage.getItem('devTreeSearch') || '{}'
                  )
                )
              }
            }
            this.$nextTick(() => {
              let item = this.MenuList[0] || {}
              this.activeIndex = window.sessionStorage.getItem('devTreeSearch')
                ? window.sessionStorage.getItem('devTreeSearch')
                : JSON.stringify({
                    BuildingId: item.BuildingId || '',
                    DeviceType: item.Id || '',
                    InstallationArea: item.InstallationArea || '',
                    TreeType: item.TreeType || 0,
                  })
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    MenuSelect(index) {
      console.log(index)
      window.sessionStorage.setItem('devTreeSearch', index)
      this.setdevTreeSearch(JSON.parse(index || '{}'))
      // let data = JSON.parse(index);
      // this.searchData.DeviceType = data.DeviceType;
      // this.searchData.BuildingId = data.BuildingId;
      // this.searchData.InstallationArea = data.InstallationArea;
      // if (this.activeName === "3") {
      //   this.pagination.PageIndex = 1;
      //   this.getDataList();
      // } else {
      //   this.upDataNum++;
      // }
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.path === '/DeviceAccounts') {
          this.isBotBut = true
          this.TreeType = window.sessionStorage.getItem('TreeType') || '0'
        } else {
          this.TreeType = '0'
          this.isBotBut = false
        }
        this.getMenuList()
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.leftMenu {
  width: 220px;
  height: calc(100%);
  overflow-y: auto;
}
.tabsBut {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .tabsBut {
  .el-tabs__content {
    display: none;
  }
  .el-tabs--border-card {
    width: 100%;
    box-shadow: none;
    .el-tabs__header {
      width: 100%;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .el-tabs__item {
    width: 50%;
    padding: 0 !important;
    text-align: center;
  }
}
</style>
